export default __webpack_public_path__ + "static/media/paypal.0db6aca5.png";